export const iconFontAwesomeMapsUtensils = (
	<i className="fa-solid fa-utensils"></i>
);
